module.exports = __webpack_public_path__ + "img/Cup.289b1686.svg";